import { LoginModal } from '../vpsb/login_modal';
import VChartsLoader from './lib/vcharts_loader.js';
import { showEphemeral, show_layout_modal, amIAnObviousBot } from './global';

class IntelligencePage {
  constructor() {
    this.vchartsLoader = new VChartsLoader();
    this.chatTimerId = null;
    this.streamScrollFrame = null;
  }

  init() {
    this.setupPromptInput();
    this.loadCharts()
    this.setupHelpMessageCross();
    this.setupDestroyButtons();
    this.askFirstQuestion();
    $('textarea#prompt-input').trigger('focus');
  }

  askFirstQuestion() {
    if (amIAnObviousBot()) {
      console.debug("Bots don't ask questions");
      return;
    }

    const question = $('div#question').data('first-question');
    if (question && question.trim() !== "") {
      $('textarea#prompt-input').val(question);
      const url = $('a#prompt-button').attr('href');
      this.submitPrompt(url);
    }
  }

  setupHelpMessageCross() {
    $('.close-cross').on('click', (e) => {
      $(e.currentTarget).parent().hide();
      localStorage.setItem('hide_help_message', true);
    });

    if (localStorage.getItem('hide_help_message') == 'true') {
      $('div.help-message').hide();
    }
  }

  setupPromptInput() {
    $('a#prompt-button').on('click', (e) => {
      e.preventDefault();
      var url = $(e.currentTarget).attr('href');
      this.submitPrompt(url);
    });

    $('textarea#prompt-input').on('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        var url = $('a#prompt-button').attr('href');
        this.submitPrompt(url);
      }
    });
  }

  loadCharts() {
    $('canvas.model-chart-canvas').each((index, canvas) => {
      var chartIndex = $(canvas).data('chart-index');
      this.loadChart(chartIndex);
    });
  }

  loadChart(chartIndex) {
    console.log(`loading chart ${chartIndex}`);
    var chartJsonScript = `script#chartjs-json-${chartIndex}`;
    var chartJson = $(chartJsonScript).text();
    var canvasElt = $(`canvas#canvas-${chartIndex}`);

    console.debug(chartJson);

    var ctx = $(canvasElt).get(0).getContext("2d");
    this.vchartsLoader.pass_through_chart(ctx, chartJson);
  }

  async submitPrompt(url) {
    var meta_csrf = $('meta[name=csrf-token]');
    var csrfToken = meta_csrf.attr('content');
    var chatId = $('div#prompt-container').data('chat-id');
    var method = $('div#prompt-container').data('new-chat') == true ? 'POST' : 'PUT';
    var prompt = $('textarea#prompt-input').val();
    if (prompt.trim() == "") {
      console.error("Won't submit an empty prompt");
      return;
    }

    var userMessage = this.appendMessageRow('user', prompt);
    var assistantMessage = this.appendMessageRow('assistant', '');
    $('body').css('cursor', 'wait');
    $('textarea#prompt-input').prop('disabled', true);
    $('textarea#prompt-input').addClass('loading');
    $('div#prompt-container').data('chat-state', 'waiting');
    this.displayChatTimer();

    try {
      var response = await fetch(url, {
        method: method,
        headers: {
          "Accept": "application/x-ndjson",
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-CSRF-Token": csrfToken,
          "X-Requested-With": "XMLHttpRequest"
        },
        body: new URLSearchParams({ chat_id: chatId || '', prompt: prompt })
      });

      if (!response.ok) {
        var errorJson = await response.json().catch(() => undefined);
        this.handlePromptError(errorJson, response.status, userMessage, assistantMessage);
        return;
      }

      var finalEvent;
      var streamError;
      var reader = response.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';

      while (true) {
        var result = await reader.read();
        if (result.done) break;

        buffer += decoder.decode(result.value, { stream: true });
        var lines = buffer.split('\n');
        buffer = lines.pop();
        lines.forEach((line) => {
          var event = this.parseStreamEvent(line);
          if (event.type == 'delta') {
            assistantMessage.html(event.html);
            this.scrollToStreamingMessage(assistantMessage);
          } else if (event.type == 'complete') {
            finalEvent = event;
          } else if (event.type == 'error') {
            streamError = event;
          }
        });
      }

      buffer += decoder.decode();
      var finalBufferedEvent = this.parseStreamEvent(buffer);
      if (finalBufferedEvent.type == 'delta') {
        assistantMessage.html(finalBufferedEvent.html);
        this.scrollToStreamingMessage(assistantMessage);
      } else if (finalBufferedEvent.type == 'complete') {
        finalEvent = finalBufferedEvent;
      } else if (finalBufferedEvent.type == 'error') {
        streamError = finalBufferedEvent;
      }

      if (streamError) {
        this.handlePromptError(streamError, response.status, userMessage, assistantMessage);
      } else if (finalEvent) {
        this.completePrompt(method, finalEvent, userMessage, assistantMessage);
      } else {
        this.handlePromptError(undefined, response.status, userMessage, assistantMessage);
      }
    } catch (error) {
      console.error('Intelligence stream failed', error);
      this.handlePromptError(undefined, 0, userMessage, assistantMessage);
    }
  }

  completePrompt(method, json, userMessage, assistantMessage) {
    $('body').css('cursor', 'default');
    this.stopChatTimer();
    assistantMessage.html(json.message);
    $('div#prompt-container').data('chat-id', json.chat_id);
    $('div#prompt-container').data('new-chat', false);
    $('div#prompt-container').data('chat-state', 'ready');
    $('textarea#prompt-input').val("");
    $('textarea#prompt-input').prop('disabled', false);
    $('textarea#prompt-input').removeClass('loading');
    $('textarea#prompt-input').trigger('focus');

    $('a#prompt-button').attr('href', json.chat_path);
    $('span#llm_tokens_credit').text(json.llm_tokens_credit);
    $('span#chat_tokens_used').text(json.chat_tokens_used);

    if (json.chart_index != null) {
      this.loadChart(json.chart_index);
    }

    $('#chat-title').text(json.chat_title);
    document.title = json.chat_title;
    this.scrollToElementWithOffset(userMessage[0], 100);

    if (method == 'POST') {
      history.pushState({}, '', json.chat_path + '/edit');
    }
  }

  handlePromptError(json, status, userMessage, assistantMessage) {
    $('body').css('cursor', 'default');
    this.stopChatTimer();
    var errMsgs = json && json.errors ? json.errors : ["An error occurred while processing your request."];
    if (json && json.status == 'sign_in') {
      var loginModal = new LoginModal(null, json.chat_signed_in_url,
            { show_skip_button: true, skip_button_label: "Start new chat", skip_url: "/intelligence_chats/new" });
      loginModal.load(errMsgs[0]);
    } else {
      console.error(`err: ${errMsgs}`, `code: ${status}`);
      show_layout_modal(errMsgs.join(' - '));
    }

    userMessage.remove();
    assistantMessage.remove();
    $('textarea#prompt-input').prop('disabled', false);
    $('textarea#prompt-input').removeClass('loading');
    $('textarea#prompt-input').trigger('focus');
    $('div#prompt-container').data('chat-state', 'error');
  }

  displayChatTimer() {
    var elapsedTime = 0;
    this.chatTimerId = setInterval(() => {
      elapsedTime += 0.1;

      $('span#chat-timer').text(`${elapsedTime.toFixed(1)}s`);
    }, 100);
  }

  stopChatTimer() {
    clearInterval(this.chatTimerId);
    this.chatTimerId = null;
  }

  parseStreamEvent(line) {
    return line ? JSON.parse(line) : {};
  }

  scrollToStreamingMessage(message) {
    if (this.streamScrollFrame) return;

    this.streamScrollFrame = requestAnimationFrame(() => {
      this.streamScrollFrame = null;
      var messageBottom = message.offset().top + message.outerHeight();
      var visibleBottom = window.scrollY + window.innerHeight - 100;
      if (messageBottom > visibleBottom) {
        window.scrollTo({ top: messageBottom - window.innerHeight + 100, behavior: 'auto' });
      }
    });
  }

  appendMessageRow(role, message) {
    const row = $('<div>', { class: `${role}-message` }).text(message);
    $('div#message-list-wrapper').append(row);
    return row;
  }

  setupDestroyButtons() {
    $('table#chat-index').on('click', '.destroy-button', (event) => {
      event.preventDefault();
      var chatRow = $(event.currentTarget).parents('tr.chat-tr');
      var itemId = chatRow.data('chat-id');
      $.ajax({
        method: "DELETE",
        url: `/accounts/intelligence_chats/${itemId}`,
        dataType: 'json',
        success: function() {
          console.log("delete success");
          showEphemeral("This conversation was deleted successfully");
          chatRow.remove();
        },
        error: (data) => {
          var err_msgs;
	        var json = data.responseJSON;
          if (typeof json !== 'undefined')
            err_msgs = json.errors;
          else
            err_msgs = ["An error occurred while deleting this chat."];

          console.error(`err: ${err_msgs}`, `code: ${data.status}`);
          show_layout_modal(err_msgs.join(' - '));
        }
      });
    });
  }

  scrollToElementWithOffset(element, offset) {
    if ($(element).length) {
      $('html, body').animate({
        scrollTop: $(element).offset().top - offset
      }, 1000);
    }
  }
}

$(document).on('turbo:load', function() {
  if ($("body.accounts_intelligence,body.llm_chats").length == 0) {
    return;
  }
  console.log("page load in intelligence.js");

  var page = new IntelligencePage();
  page.init();
} );
